module.exports = __webpack_public_path__ + "img/331fc3da2da9efc14e84938fd8e0a62d.png";